/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  DigitalAsset,
  Blockchain,
  DigitalWithdrawalRequest,
  WithdrawDigitalAssetBody,
  GetDepositAddresses200,
  GetDepositAddressesParams,
  DigitalDepositAddress,
  GenerateDepositAddressBody
} from './schema'



/**
 * Get supported digital assets and networks
 * @summary Get Supported Digital Assets
 */
export const getSupportedDigitalAssets = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DigitalAsset[]>> => {
    return axios.get(
      `/digital-custody/assets`,options
    );
  }


export const getGetSupportedDigitalAssetsQueryKey = () => [`/digital-custody/assets`];

    
export type GetSupportedDigitalAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedDigitalAssets>>>
export type GetSupportedDigitalAssetsQueryError = AxiosError<unknown>

export const useGetSupportedDigitalAssets = <TData = Awaited<ReturnType<typeof getSupportedDigitalAssets>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportedDigitalAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportedDigitalAssetsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedDigitalAssets>>> = ({ signal }) => getSupportedDigitalAssets({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSupportedDigitalAssets>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get supported blockchains
 * @summary Get Supported Blockchains
 */
export const getSupportedBlockchains = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blockchain[]>> => {
    return axios.get(
      `/digital-custody/chains`,options
    );
  }


export const getGetSupportedBlockchainsQueryKey = () => [`/digital-custody/chains`];

    
export type GetSupportedBlockchainsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedBlockchains>>>
export type GetSupportedBlockchainsQueryError = AxiosError<unknown>

export const useGetSupportedBlockchains = <TData = Awaited<ReturnType<typeof getSupportedBlockchains>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportedBlockchains>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportedBlockchainsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedBlockchains>>> = ({ signal }) => getSupportedBlockchains({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSupportedBlockchains>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a Withdraw Request to withdraw digital asset from a account to a destination address
 * @summary Create Withdrawal Request
 */
export const withdrawDigitalAsset = (
    withdrawDigitalAssetBody: WithdrawDigitalAssetBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DigitalWithdrawalRequest>> => {
    return axios.post(
      `/digital-custody/withdrawal`,
      withdrawDigitalAssetBody,options
    );
  }



    export type WithdrawDigitalAssetMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawDigitalAsset>>>
    export type WithdrawDigitalAssetMutationBody = WithdrawDigitalAssetBody
    export type WithdrawDigitalAssetMutationError = AxiosError<unknown>

    export const useWithdrawDigitalAsset = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawDigitalAsset>>, TError,{data: WithdrawDigitalAssetBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawDigitalAsset>>, {data: WithdrawDigitalAssetBody}> = (props) => {
          const {data} = props ?? {};

          return  withdrawDigitalAsset(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof withdrawDigitalAsset>>, TError, {data: WithdrawDigitalAssetBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get a list of deposit addresses
 * @summary Get Deposit Addresses
 */
export const getDepositAddresses = (
    params?: GetDepositAddressesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetDepositAddresses200>> => {
    return axios.get(
      `/digital-custody/deposit-addresses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetDepositAddressesQueryKey = (params?: GetDepositAddressesParams,) => [`/digital-custody/deposit-addresses`, ...(params ? [params]: [])];

    
export type GetDepositAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getDepositAddresses>>>
export type GetDepositAddressesQueryError = AxiosError<unknown>

export const useGetDepositAddresses = <TData = Awaited<ReturnType<typeof getDepositAddresses>>, TError = AxiosError<unknown>>(
 params?: GetDepositAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDepositAddresses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDepositAddressesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepositAddresses>>> = ({ signal }) => getDepositAddresses(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getDepositAddresses>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Generates a new blockchain deposit address for an account for a given asset/chain pair. UTGL may reuse addresses on blockchains that support reuse. For example, if you're generated two addresses for depositing USDC and USDC, both on Ethereum, you may see the same Ethereum address returned. This behaviour cannot be assumed and should not be relied upon. Your implementation should generate an address for each asset and chain you want to support.
Depositing cryptocurrency to a generated address will credit the associated account with the value of the deposit net of any fees (if applicable).
 * @summary Generate Deposit Address
 */
export const generateDepositAddress = (
    generateDepositAddressBody: GenerateDepositAddressBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DigitalDepositAddress[]>> => {
    return axios.post(
      `/digital-custody/deposit-addresses`,
      generateDepositAddressBody,options
    );
  }



    export type GenerateDepositAddressMutationResult = NonNullable<Awaited<ReturnType<typeof generateDepositAddress>>>
    export type GenerateDepositAddressMutationBody = GenerateDepositAddressBody
    export type GenerateDepositAddressMutationError = AxiosError<unknown>

    export const useGenerateDepositAddress = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDepositAddress>>, TError,{data: GenerateDepositAddressBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDepositAddress>>, {data: GenerateDepositAddressBody}> = (props) => {
          const {data} = props ?? {};

          return  generateDepositAddress(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof generateDepositAddress>>, TError, {data: GenerateDepositAddressBody}, TContext>(mutationFn, mutationOptions)
    }
    